import React, { useRef } from 'react';

import styles from './ImportButton.module.css';

const ImportButton = (props) => {
  const { className, children, onImport } = props;
  const fileInputRef = useRef(null);

  const changeHandler = (event) => {
    const success = confirm('Are you shure?');
    if (success) {
      console.log('===FILE', event.target.files[0]);
      onImport(event.target.files[0]);
    }
    fileInputRef.current.value = null;
    // props.input.onChange(e.target.files);
    // console.log('===event.target?.files', event.target?.files);
    // let file = event.target?.files?.[0] || {};
  };

  return (
    <div className={styles.wrapper}>
      <label className={className}>
        <input 
          ref={fileInputRef}
          className={styles.fileInput} 
          type="file" 
          accept=".csv"
          onChange={changeHandler}
        />
        {children}
      </label>
    </div>
  );
};

export default ImportButton;
